import request from '@/utils/request'

// 获取品类对应属性参数
export function getAttributeParams(data) {
  return request({
    url: '/productAttributeGroup/list/params',
    method: 'post',
    params: data
  })
}

// 根据mchtId查询一条商家数据
export function getOneByMchtId (params) {
  return request({
    url: '/pmsMchtShopInfo/getOneByMchtId',
    method: 'get',
    params: params
  })
}

// 根据用户名或姓名分页获取用户列表
export function getSupplierList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params
  })
}

// 获取子标签列表
export function getLabelList(data) {
  return request({
    url: '/label/getLabelList',
    method: 'post',
    params: data
  })
}

// 获取商品标签列表
export function getProductLableList(data) {
  return request({
    url: '/label/getProductLableList',
    method: 'post',
    params: data
  })
}

// 删除
export function fetchList(params) {
  return request({
    url: '/home/newProduct/list',
    method: 'get',
    params: params
  })
}

export function updateRecommendStatus(data) {
  return request({
    url: '/home/newProduct/update/recommendStatus',
    method: 'post',
    data: data
  })
}

export function deleteNewProduct(data) {
  return request({
    url: '/home/newProduct/delete',
    method: 'post',
    data: data
  })
}

export function createNewProduct(data) {
  return request({
    url: '/home/newProduct/create',
    method: 'post',
    data: data
  })
}

export function updateNewProductSort(params) {
  return request({
    url: '/home/newProduct/update/sort/' + params.id,
    method: 'post',
    params: params
  })
}

export function saveManualAttribute(params) {
  return request({
    url: '/productAttribute/saveManualAttribute',
    method: 'post',
    data: params
  })
}

export function createProductAttribute(data) {
  return request({
    url: '/productAttribute/saveManualAttribute/single',
    method: 'post',
    data
  })
}

export function createProductSpecs(data) {
  return request({
    url: '/productAttribute/saveManualAttribute/specs',
    method: 'post',
    data
  })
}

export function deleteProductAttribute(data) {
  return request({
    url: '/productAttribute/manualAttribute/single',
    method: 'delete',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/newProduct.js